// extracted by mini-css-extract-plugin
module.exports = {"header":"_0e045","disclaimer":"b2ad3","spinner":"_11892","row":"cf4d5","content":"d6615","form":"_7d655"};